module.exports = __webpack_public_path__ + "static/img/hd.95b8eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/hd.png
// module id = WOXM
// module chunks = 4